/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import { Wrap, Groupbutton, ModalBox, StyledButton } from './styles';

import Layer from 'services/models/Layer';
import { getTurfedFeatures } from 'services/utils/layerUtils';
import { measureArea } from 'services/utils/measures';
import NoticeNotRun from 'services/utils/noticeNotRun';

import ButtonTooltip from '../../ButtonTooltip';

import { ModalBody } from 'views/MapView/components/CustomModalSaveAsLayer';
import {CustomModalSaveAsLayer} from 'views/MapView/components/CustomModalSaveAsLayer';

import Icon from '@map/components/Icons';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * useFormik é um hook personalizado do React que retornará
 * todos os estados e auxiliares do Formik diretamente.
 */
import { useFormik } from 'formik';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import MultiSelect from 'views/MapView/components/Formik/components/MultiSelect';
import SimpleModal from 'views/MapView/components/SimpleModal';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';
import * as Yup from 'yup';

const onCloseModalError = () => {
  ReactDOM.render(null, document.getElementById('alert'));
};

/**
 * Ferramenta Dissolver
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @param {*} props Resto
 * @returns 
 */
export const Dissolve = ({ mapContext, isActive, setIsActive, ...props }) => {
  const [arrSelectedLayers, setArrSelectedLayers] = useState([]);
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [openModalSelectAttribute, setOpenModalSelectAttribute] = useState(false);
  const [runingDissolve, setRuningDissolve] = useState(false);
  const [collectionDissolve, setCollectionDissolve] = useState({});
  const [comboAttribute, setComboAttribute] = useState([]);
  const [attributeNames, setAttributeNames] = useState([]);
  const { layers, map, addLayer, setLoadingInMap } = useMap();

  const formik = useFormik({
    initialValues: {
      layerName: '',
      layerStyle: null,
    },
    validationSchema: Yup.object().shape({
      layerName: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (values) => {
      saveAsLayer(values.layerName, values.layerStyle);
    },
  });
  const { resetForm } = formik;


  /**
   * Seleciona as camadas que serão utilizadas para Dissolver
   * @param {*} 
   * @param {*} 
   * @returns
   * 
   * **/

  const getComboAttribute = useCallback(() => {
    const combo = [];
    arrSelectedLayers.forEach((layer) => {
      layer.leafletLayer.eachLayer((feature) => {
        const newFeatureProperties = feature.feature.properties;
        const newFeaturePropertiesKeys = Object.keys(newFeatureProperties);
        newFeaturePropertiesKeys.forEach((key) => {
          if (!combo.includes(key)) {
            combo.push(key);
          }
        });
      });
    });
    setComboAttribute(combo);
  }, [arrSelectedLayers]);

  useEffect(() => {
    getComboAttribute();
  }, [getComboAttribute]);

  /**
   * Salva a operação de Dissolver realizada em uma nova camada, que será lista no menu
   * @param {*} layerName Nome que deverá aparecer no menu
   * @param {*} layerStyle Estilo de como a camada deverá ser representada no mapa   
   */


  const saveAsLayer = useCallback((layerName, layerStyle) => {
    if (collectionDissolve) {
      const customRender = L.canvas({ pane: 'mixedPane' });
      let options = {
        pane: 'mixedPane',
        renderer: customRender,
        style: layerStyle,
      };

      const geoJsonLayer = L.geoJSON(collectionDissolve, options);
      let layerToAdd = new Layer(
        null,
        'criada',
        null,
        layerName,
        null,
        null,
        null,
        null,
        null
      );
      layerToAdd.setLeafletLayer(geoJsonLayer);
      layerToAdd.setLayerStyle(layerStyle);
      let countIdFeature = 1;
      layerToAdd.leafletLayer.eachLayer((feature) => {
        let newFeatureProperties = {};
        newFeatureProperties.ID_GBA = countIdFeature;
        newFeatureProperties = {
          ...newFeatureProperties,
          ...feature.feature.properties,
        }
        const perimeter = turf.length(feature.feature, {
          units: 'meters',
        });

        newFeatureProperties['Perímetro (m)'] = perimeter.toFixed(2);        
        newFeatureProperties['Área (m²)'] = measureArea(feature.feature.geometry.coordinates, true);
        newFeatureProperties['Área (ha)'] = measureArea(feature.feature.geometry.coordinates, true) / 10000;
        feature.feature['properties'] = newFeatureProperties;

        countIdFeature++;
      });
      addLayer(layerToAdd);
      setSaveModalOpen(false);
    }
  }, [collectionDissolve, addLayer]);

  /**
   * Reseta formik para estado inicial e fecha modal
   */
  const handleCloseSaveModal = useCallback(() => {
    resetForm();
    setSaveModalOpen(false);
    setOpenModalSelectAttribute(false);
    setAttributeNames([]);
  }, [resetForm]);

  /**
 * Inicia procedimento para execução de Dissolve
 */

  const runDissolve = useCallback(async () => {
    if (runingDissolve) return;
    setRuningDissolve(true);
    setLoadingInMap(true);

    const promise = new Promise((resolve, reject) => {
      setTimeout(function () {
        let featuresDissolve = [];
        let arrTurfedFeatures = [];

 
        arrSelectedLayers.forEach((layer) => {
          arrTurfedFeatures = getTurfedFeatures(layer, true);
          arrTurfedFeatures.forEach((feature) => {
            const coordinates = feature.geometry.coordinates;
            if (feature.geometry.type === 'Polygon') {
              const polygon = turf.polygon(coordinates);
              featuresDissolve.push(polygon);
            } else if (feature.geometry.type === 'MultiPolygon') {
              coordinates.forEach((multiPolygonCoordinates) => {
                const polygon = turf.polygon(multiPolygonCoordinates);
                featuresDissolve.push(polygon);
              });
            }
          });
        });
        
        let arrayTurfedFeatures = [];
        featuresDissolve.forEach((fd) => {
          let turfPolygon = turf.polygon(fd.geometry.coordinates);
          arrayTurfedFeatures.push(turfPolygon);

        });
        const fc = turf.featureCollection(arrayTurfedFeatures);        

        try {
          let dissolved = turf.dissolve(fc);
          
          dissolved.features.forEach((d) => {
            if (d.geometry.type === 'Polygon') {
              d.geometry.type = 'MultiPolygon';
              d.geometry.coordinates = [d.geometry.coordinates];
            }
          });
  
          dissolved = turf.combine(dissolved);
          dissolved.features.forEach((d) => {
            delete d.properties.collectedProperties;
          });
  
          resolve(dissolved);
        } catch (error) {          
          reject(error);          
        }
        
      }, 500);
    });

    promise.then((dissolved) => {
      setCollectionDissolve(dissolved);
      setOpenModalSelectAttribute(false);
      setRuningDissolve(false);
      setLoadingInMap(false);
      setAttributeNames([]);
      setSaveModalOpen(true);
    }).catch(() => {
      NoticeNotRun({
        title: 'Dissolver',
        message: 'Não foi possível realizar operação.',
        buttonText: 'OK',
      });
      setRuningDissolve(false);
      setLoadingInMap(false);
      setAttributeNames([]);
    });
  }, [arrSelectedLayers, runingDissolve, setLoadingInMap]);

  

const runDissolveWithAttribute = useCallback(async () => {
  if (runingDissolve) return;
  setRuningDissolve(true);
  setLoadingInMap(true);

  const promise = new Promise((resolve, reject) => {
    setTimeout(function () {
      try {
        let dissolved = []; 
        attributeNames.forEach((name) => { 
          dissolved = dissolved.map((d) => { 
            d.features.forEach((f) => { 
              f.properties[name] = f.properties[name] || ''; 
            });
            return d;
          });

          let featuresDissolve = processSelectedLayers(arrSelectedLayers);
          let featuresDissolveCollection = turf.dissolve(turf.featureCollection(featuresDissolve), { propertyName: name }); 
          dissolved.push(featuresDissolveCollection); 
        });

        const combinedFeatures = combineCoordinates(dissolved);
        const cl = turf.featureCollection(combineFeaturesByAttribute(combinedFeatures, attributeNames)); 
        resolve(cl); 
      } catch (error) {          
        reject(error);          
      }
      
    }, 500);
  });

  promise
    .then((dissolved) => {
      setCollectionDissolve(dissolved);
      setOpenModalSelectAttribute(false);
      setRuningDissolve(false);
      setLoadingInMap(false);
      setAttributeNames([]);
      setSaveModalOpen(true);
    })
    .catch(() => {      
      NoticeNotRun({
        title: 'Dissolver',
        message: 'Não foi possível realizar operação.',
        buttonText: 'OK',
      });
      setRuningDissolve(false);
      setLoadingInMap(false);
      setAttributeNames([]);
    });
}, [arrSelectedLayers, runingDissolve, setLoadingInMap, attributeNames]);


function processSelectedLayers(arrSelectedLayers) {
  const featuresDissolve = [];
  arrSelectedLayers.forEach((layer) => {
    if(layer.selectedFeatures.length > 0) {
      layer.selectedFeatures.forEach((feature) => {
        const coordinates = feature.geometry.coordinates;
        if (feature.geometry.type === 'Polygon') {
          const polygon = turf.polygon(coordinates,{ ...feature.properties });
          featuresDissolve.push(polygon);
        } else if (feature.geometry.type === 'MultiPolygon') {
          coordinates.forEach((multiPolygonCoordinates) => {
            const polygon = turf.polygon(multiPolygonCoordinates, { ...feature.properties });
            featuresDissolve.push(polygon);
          });
        }
      });
    }else{
    layer.leafletLayer.eachLayer((feature) => {
      const coordinates = feature.feature.geometry.coordinates;
      if (feature.feature.geometry.type === 'MultiPolygon') {
        coordinates.forEach((coordinate) => {
          const polygon = turf.polygon(coordinate, { ...feature.feature.properties });
          featuresDissolve.push(polygon);
        });
      } else {
        const polygon = turf.polygon(coordinates, { ...feature.feature.properties });
        featuresDissolve.push(polygon);
      }
    });
    }
  });

  return featuresDissolve;
}


const combineCoordinates = (collection) => {
  const coordinatesMap = {};
  const combinedFeatures = [];  

  collection.forEach((featureCollection) => {
    featureCollection.features.forEach((feature) => {       
      const coordinates = JSON.stringify(feature.geometry.coordinates); 
      if (!coordinatesMap[coordinates]) { 
        coordinatesMap[coordinates] = [];
      }
      coordinatesMap[coordinates].push(feature); 
    });
  });

  for (const coordinates in coordinatesMap) { // percorre o objeto de coordenadas
    const features = coordinatesMap[coordinates]; // pega o array de features    
    const featureProperties = { ...features[0].properties }; // pega as propriedades da primeira feature do array
    let coordinatesToPolygon = [];

    features.forEach((feature) => { // percorre o array de features      
      Object.assign(featureProperties, feature.properties); // adiciona as propriedades da feature no objeto de propriedades      
      coordinatesToPolygon = feature.geometry.coordinates.filter((arrCoordinates) => {        
        return arrCoordinates.length >= 4;
      });      
    });
    // const combinedFeature = turf.polygon(JSON.parse(coordinates), featureProperties); // cria o poligono combinado
    const combinedFeature = turf.polygon(coordinatesToPolygon, featureProperties); // cria o poligono combinado
    combinedFeatures.push(combinedFeature);
  }

  return combinedFeatures; 
};

function combineFeaturesByAttribute(features, attributeName) { 
  const combinedFeatures = [];

  const groupedFeatures = features.reduce((acc, feature) => { 
    const attributeValue = feature.properties[attributeName];

    if (!acc[attributeValue]) {
      acc[attributeValue] = [feature];
    } else { 
      acc[attributeValue].push(feature);
    }
    return acc;
  }, {});

  for(const [_, value] of Object.entries(groupedFeatures)) { 
    const array = []; 
    value.forEach((feature) => {  
      array.push(feature.geometry.coordinates); 
    });
    const multiPoly = turf.multiPolygon(array, {...value[0].properties }); 
    combinedFeatures.push(multiPoly);
  }
  return combinedFeatures; 
}


  /** EFFECTS */

  /**
   * Habilita ferramenta de acordo com a camada selecionada, visibilidade e tipo
   */
  useEffect(() => {
    let selectedLayers = layers.filter((l) => l.isSelected && l.visible);
    if (
      (selectedLayers.length === 1
        && ["importada", "criada"].includes(selectedLayers[0].type)
        && ["Polygon", "MultiPolygon"].includes(selectedLayers[0].dataType))
    ) {
      setArrSelectedLayers([selectedLayers[0]]);
    } else if ((selectedLayers.length === 2
      && ['importada', 'criada'].includes(selectedLayers[0].type)
      && ['importada', 'criada'].includes(selectedLayers[1].type)
      && ["Polygon", "MultiPolygon"].includes(selectedLayers[0].dataType)
      && ["Polygon", "MultiPolygon"].includes(selectedLayers[1].dataType))
    ) {
      setArrSelectedLayers([selectedLayers[0], selectedLayers[1]]);
    } else {
      setArrSelectedLayers([]);
    }
  }, [layers]);


  /**
   * Desabilita ferramenta caso não haja camada selecionada
   */
  useEffect(() => {
    if (arrSelectedLayers.length === 0 && isActive) {
      setIsActive(false);
    }
  }, [arrSelectedLayers, isActive, setIsActive]);

  /**
   * Reseta ferramenta ao ser desabilitada
   */
  useEffect(() => {
    if (!isActive) {
      handleCloseSaveModal();
    }
  }, [isActive, handleCloseSaveModal]);

  /**
   * Adiciona e executa um evento customizado. Ao final remove evento.
   */

  useEffect(() => {
    const handleRunDissolve = () => {
      if (attributeNames.length > 0) {
        runDissolveWithAttribute();
      } else {
        runDissolve();
      }
    };

    if (isActive && !runingDissolve) {
      map.on('run-dissolve', handleRunDissolve);
      map.fire('run-dissolve');
      setIsActive(false);
    }

    return () => {
      map.off('run-dissolve', handleRunDissolve);
    };
  }, [isActive, runingDissolve, map, runDissolve, runDissolveWithAttribute, setIsActive, attributeNames]);


  return (
    <Wrap>
      <ButtonTooltip
        tooltip={Dissolve.properties.alias}
        description={Dissolve.properties.description}
        onClick={() => {
          setOpenModalSelectAttribute(true);
        }}
        tooltipDisabled={isActive}
        active={isActive}
        disabled={arrSelectedLayers.length === 0}
      >
        <Icon i="map-toolbar-dissolve"></Icon>
      </ButtonTooltip>

      <SimpleModal
        title="Dissolver"
        activeWithBgColor
        open={openModalSelectAttribute}
        onClose={handleCloseSaveModal}
      >
        <ModalBody>
          <MultiSelect
            label="Atributo"
            optionsConfig={comboAttribute}
            setPersonName={setAttributeNames}
            personName={attributeNames}
          />

          <Groupbutton className='group-button'>
            <Button
              className='button-cancel'
              variant="contained"
              color="primary"
              component="div"
              onClick={() => {
                setOpenModalSelectAttribute(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              className='button-next'
              variant="contained"
              color="primary"
              component="div"
              onClick={() => {
                setIsActive();
                setTimeout(() => {
                  // setSaveModalOpen(true);
                  setOpenModalSelectAttribute(false);
                }, 500);
              }}
            >
              Próximo
            </Button>
          </Groupbutton>
        </ModalBody>

      </SimpleModal>

      <CustomModalSaveAsLayer
        title="Salvar Camada"
        saveModalOpen={saveModalOpen}
        handleCloseSaveModal={handleCloseSaveModal}
        formik={formik}
        SliderColorPicker={<SliderColorPicker
            geometryType="Polygon"
            autoSelect={false}
            selectedSymbology={formik.values.layerStyle}
            onSelect={(style) => formik.setFieldValue('layerStyle', style)}
          />}
      />
    </Wrap>
  );
};


Dissolve.properties = {
  id: 'CPN-TB-A-DISSOLVE',
  alias: 'Dissolver',
  description: 'Dissolver (anular) as áreas que sobrepõem, compartilham limite ou possuem um atributo em comum. Selecionado apenas uma camada criada ou importada do tipo polígono, podendo especificar feições',
};

export default Dissolve;
